module.exports = __webpack_public_path__ + "static/media/teambuildingarenalogo_02.b4691c3b.png";